import type { ArrivalAnnotation } from '@/shared/api';

export type AnnotationTool = 'arrow' | 'circle' | 'rect' | 'dot';

export const ANNOTATION_KIND_LABELS: Record<string, string> = {
  arrow: 'Pfeil',
  circle: 'Kreis',
  rect: 'Rahmen',
  dot: 'Punkt',
};

/**
 * Baut aus einer Zieh-Geste die Markierung. Ein Punkt braucht keinen zweiten Punkt; bei den
 * übrigen Formen ist eine zu kurze Geste ein Klick und kein Zug — dann entsteht eine Form in
 * Standardgröße, statt einer, die man nicht sieht.
 */
export function nextAnnotation(
  tool: AnnotationTool,
  color: string,
  from: { x: number; y: number },
  to: { x: number; y: number },
): ArrivalAnnotation {
  const clamp = (value: number) => Math.min(1, Math.max(0, value));
  const dragged = Math.abs(to.x - from.x) > 0.02 || Math.abs(to.y - from.y) > 0.02;
  const end = dragged ? to : { x: from.x + 0.15, y: from.y + 0.15 };
  return {
    kind: tool,
    color,
    x: clamp(from.x),
    y: clamp(from.y),
    x2: tool === 'dot' ? clamp(from.x) : clamp(end.x),
    y2: tool === 'dot' ? clamp(from.y) : clamp(end.y),
  };
}
